import ReturnPolicyEmbed from '../src/ReturnPolicyEmbed';
export default ReturnPolicyEmbed;
